import {getCurrentInstance, reactive, ref} from 'vue';
import {useDashboardDataStore} from '@/stores/dashboard/dashboardDataStore';
import commonFunction from '@/commons/commonFunction';
import dashboardParamApi from '@/apis/dashboard/dashboardParamApi';
import {useDashboardParamStore} from '@/stores/dashboard/dashboardParamStore';
import IndexedDB from '@/commons/indexedDB';
import {dashboardDataGroup} from './dashboardDataGroup';
import {useDbOptionStore} from '@/stores/dbOptionStore';

// import {MD5} from 'crypto-js';
import moment from 'moment';
export const useCustomDashboard = () => {
  const {proxy} = getCurrentInstance();
  //  dboption
  const dbOptions = useDbOptionStore();
  const isUseQLTS = dbOptions.state?.UseQLTSVN; // có đang kết nối QLTS không

  const dashboardMessageGroup = ref([]); // danh sách chứa thông báo ava
  /**
   * lấy dữ liệu dashboard
   * ntduong2 4.3.2024
   */
  const getCustomData = (paramKey, id, type, unit, includeSpecificBudgetItem = false, isZoom = false) => {
    // Đánh dấu bản ghi
    // 0: Bản ghi chung
    // 1: Bản ghi không chứa các mục 0051, 0052, 0099
    // 2: Bản ghi chứa các mục 0051, 0052, 0099
    // Nếu tích chọn không chứa các mục 0051, 0052, 0099 => Khác 2
    // Nếu Không tích chọn không chứa các mục 0051, 0052, 0099 => Khác 1
    const allDashboardData = useDashboardDataStore().items.filter(
      x => x.include_specific_budget_item != (includeSpecificBudgetItem == true ? 2 : 1),
    );

    let dashboardData = allDashboardData
      .filter(item => item.dashboard_param_key == paramKey && item.dashboard_group == id)
      .sort(function (a, b) {
        return a.sort_order - b.sort_order;
      });

    if (dashboardData.length > 4 && type == proxy.$ms.constant.ChartType.Column && !isZoom) {
      dashboardData = dashboardData.splice(0, 4);
    }
    if (dashboardData.length > 0) {
      switch (paramKey) {
        case 'dashboard_budget_plan':
          let currentData = dashboardData.filter(
            x => x.include_specific_budget_item != (includeSpecificBudgetItem == true ? 2 : 1),
          );
          switch (id) {
            case 1:
              return currentData.map(x => x.debit_amount / unit);
            case 2:
              if (currentData.some(x => x.debit_amount || x.credit_amount)) {
                return [
                  {
                    name: 'Tạm ứng',
                    data: currentData.map(x => x.debit_amount / unit),
                  },
                  {
                    name: 'Thực chi',
                    data: currentData.map(x => x.credit_amount / unit),
                  },
                ];
              }
              return [];
          }
          break;
        case 'dashboard_receipt_expense':
          switch (id) {
            case 1:
              if (dashboardData.some(x => x.debit_amount)) {
                return dashboardData
                  .filter(item => item.sort_order == 1 || item.sort_order == 2)
                  .map(x => x.debit_amount / unit);
              }
              return [];
            case 2:
              return [
                {
                  name: 'Số thu',
                  data: dashboardData.map(x => x.debit_amount / unit),
                },
                {
                  name: 'Số chi',
                  data: dashboardData.map(x => x.credit_amount / unit),
                },
              ];
            case 3:
              return [
                {
                  name: 'Số thu hộ trong kỳ',
                  data: dashboardData.map(x => x.credit_amount / unit),
                },
                {
                  name: 'Số đã nộp cấp trên',
                  data: dashboardData.map(x => x.debit_amount / unit),
                },
              ];
            case 4:
              return [
                {
                  name: 'Số nhận chi hộ trong kỳ',
                  data: dashboardData.map(x => x.credit_amount / unit),
                },
                {
                  name: 'Số đã chi hộ trong kỳ',
                  data: dashboardData.map(x => x.debit_amount / unit),
                },
              ];
          }
          break;

        default:
          break;
      }
    }
    return [];
  };

  /**
   * thiết lập cấu hình dash board
   * ntduong2 4.3.2024
   */
  const getCustomOption = (paramKey, id, type, unitText, includeSpecificBudgetItem = false, isZoom = false) => {
    const allDashboardData = useDashboardDataStore().items.filter(
      x => x.include_specific_budget_item != (includeSpecificBudgetItem == true ? 2 : 1),
    );

    let dashboardData = allDashboardData
      .filter(item => item.dashboard_param_key == paramKey && item.dashboard_group == id)
      .sort(function (a, b) {
        return a.sort_order - b.sort_order;
      });

    if (dashboardData.length > 4 && type == proxy.$ms.constant.ChartType.Column && !isZoom) {
      dashboardData = dashboardData.splice(0, 4);
    }
    // Lấy giá trị của biến màu từ CSS
    const root = document.body;
    const primaryColor = getComputedStyle(root).getPropertyValue('--primary').trim();
    const primaryActiveColor = getComputedStyle(root).getPropertyValue('--primary-active').trim();
    let width = 0;
    if (document.getElementsByClassName('dashboard-item')[0]) {
      width = document.getElementsByClassName('dashboard-item')[0].clientWidth / 2;
    }

    if (type == proxy.$ms.constant.ChartType.Column) {
      return {
        customOptions: {
          annotations: {
            yaxis: [
              {
                y: 0,
                strokeDashArray: 0,
                borderColor: '#c1c4cc',
                opacity: 0.8,
                offsetX: 0,
                offsetY: 0,
              },
            ],
          },
          states: {
            hover: {
              filter: {
                type: 'none' /* none, lighten, darken */,
              },
            },
            active: {
              filter: {
                type: 'none' /* none, lighten, darken */,
              },
            },
          },
          yaxis: {
            forceNiceScale: true,
            max: function (max) {
              return max * 1.2; // Thêm 20% không gian phía trên
            },
            labels: {
              formatter: function (value) {
                return proxy.$ms.format.formatAmount(value, {hideCurrencySymbol: true});
              },
              style: {
                fontSize: window.innerWidth <= 1366 ? '11px' : '13px',
                fontFamily: 'NotoSans-Regular',
                colors: ['#707070'],
              },
            },
            axisBorder: {
              show: true,
              color: '#c1c4cc',
            },
          },
          xaxis: {
            categories: dashboardData.map(item => item.title),
            labels: {
              style: {
                fontSize: window.innerWidth <= 1366 ? '11px' : '13px',
                fontFamily: 'NotoSans-Regular',
                fontWeight: 600,
              },
            },
            axisBorder: {
              show: false,
            },
          },
          grid: {
            show: false,
          },

          legend: {
            position: 'bottom',
            offsetY: 0,
            offsetX: 0,
            itemMargin: {
              horizontal: 8,
              vertical: 8,
            },
            horizontalAlign: 'left', // thuộc tính này giúp căn lề chú thích nhé có 3 thuộc tính là left | right | center (vcdoan). Căn dọc thì fix css
            markers: {
              shape: 'square',
              width: 12,
              height: 12,
              radius: 4,
              strokeWidth: 0,
            },
            formatter: function (seriesName, opts) {
              return seriesName;
            },
            fontSize: '13px',
            fontFamily: 'NotoSans-Regular',
            fontWeight: 600,
          },
          colors: [primaryColor, '#FF9800'], // màu các cột
          tooltip: {
            enabled: true,
            custom: function ({series, seriesIndex, dataPointIndex, w}) {
              let amount = proxy.$ms.format.formatData(series[seriesIndex][dataPointIndex], {
                formatType: proxy.$ms.constant.FormatType.Amount,
                hideCurrencySymbol: true,
              });
              if (dataPointIndex == series[seriesIndex].length - 1) {
                return `<div class="arrow_box_bottom"><span class="value">${amount} ${unitText}</span></div>`;
              } else {
                return `<div class="arrow_box"><span class="value">${amount} ${unitText}</span></div>`;
              }
            },
            followCursor: true, // vị trí theo chuột
          },
          plotOptions: {
            bar: {
              columnWidth: window.innerWidth <= 1366 ? '30px' : '50px',
              dataLabels: {
                position: 'top', // top, center, bottom
                offsetY: -20,
              },
              fill: {
                opacity: 1,
              },
            },
          },
          stroke: {
            show: true,
            width: 8,
            colors: ['transparent'],
          },
          fill: {
            opacity: 1,
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              const maxLength = 6; // Tối đa ký tự để hiển thị
              let text =
                proxy.$ms.format.formatAmount(val, {hideCurrencySymbol: true}) == 0
                  ? ''
                  : proxy.$ms.format.formatAmount(val, {hideCurrencySymbol: true});
              if (text.length > maxLength) {
                return '';
              } else {
                return text;
              }
            },
            offsetY: -20,
            style: {
              fontSize: window.innerWidth <= 1366 ? '10px' : '13px',
              fontFamily: 'NotoSans-Regular',
              colors: ['#111'],
              fontWeight: '600',
            },
          },
        },
      };
    } else if (type == proxy.$ms.constant.ChartType.Donut) {
      switch (paramKey) {
        case 'dashboard_budget_plan':
          return {
            customOptions: {
              states: {
                hover: {
                  filter: {
                    type: 'none' /* none, lighten, darken */,
                  },
                },
                active: {
                  filter: {
                    type: 'none' /* none, lighten, darken */,
                  },
                },
              },
              tooltip: {
                enabled: true,
                custom: function ({series, seriesIndex, dataPointIndex, w}) {
                  let amount = proxy.$ms.format.formatData(series[seriesIndex], {
                    formatType: proxy.$ms.constant.FormatType.Amount,
                    hideCurrencySymbol: true,
                  });
                  return `<div class="arrow_box donut-arrow-box"><span class="value">${amount} ${unitText}</span></div>`;
                },
                followCursor: true, // vị trí theo chuột
              },
              colors:
                dashboardData.length == 2
                  ? [primaryColor, primaryActiveColor]
                  : ['#FF9800', primaryColor, primaryActiveColor],
              labels: dashboardData.map(item => item.title),
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: 0,
              },
              plotOptions: {
                pie: {
                  customScale: 0.9,
                  donut: {
                    background: 'transparent',
                    labels: {
                      // Hiện ở bên trong donut
                      show: true,
                      name: {
                        show: true,
                        fontSize: (26 * width) / 400,
                        fontFamily: 'NotoSans-Regular',
                        color: undefined,
                        offsetY: 35,
                        formatter: function (val) {
                          return val;
                        },
                      },
                      value: {
                        show: true,
                        fontSize: (48 * width) / 400,
                        fontFamily: 'NotoSans-Regular',
                        fontWeight: 700,
                        color: undefined,
                        offsetY: -5,
                        formatter: function (val) {
                          return proxy.$ms.format.formatAmount(val, {hideCurrencySymbol: true});
                        },
                      },
                      total: {
                        show: true,
                        showAlways: true,
                        label: `${unitText}`,
                        color: '#000',
                        formatter: function (w) {
                          let sum = w.globals.seriesTotals.reduce((a, b) => {
                            return a + b;
                          }, 0);

                          return proxy.$ms.format.formatAmount(sum, {hideCurrencySymbol: true});
                        },
                      },
                    },
                  },
                },
              },
              legend: {
                fontSize: '13px',
                fontFamily: 'NotoSans-Regular',
                fontWeight: 500,
                position: 'bottom',
                horizontalAlign: 'start-custom',
                width: width,
                // itemMargin: {
                //   horizontal: 10,
                //   vertical: 8,
                // },
                markers: {
                  shape: 'square',
                  width: 12,
                  height: 12,
                },
                itemMargin: {
                  horizontal: 10,
                  vertical: 5,
                },
                labels: {
                  colors: '#111111',
                  useSeriesColors: false,
                },
                // markers: {
                // },
                formatter: function (seriesName, opts) {
                  let amount = proxy.$ms.format.formatAmount(opts.w.globals.series[opts.seriesIndex], {
                    hideCurrencySymbol: true,
                  });
                  return `<div>${seriesName}</div><div class="unit-text">${amount} ${unitText}</div>`;
                },
              },
            },
          };
        case 'dashboard_receipt_expense':
          return {
            customOptions: {
              states: {
                hover: {
                  filter: {
                    type: 'none' /* none, lighten, darken */,
                  },
                },
                active: {
                  filter: {
                    type: 'none' /* none, lighten, darken */,
                  },
                },
              },
              tooltip: {
                enabled: true,
                custom: function ({series, seriesIndex, dataPointIndex, w}) {
                  let amount = proxy.$ms.format.formatData(series[seriesIndex], {
                    formatType: proxy.$ms.constant.FormatType.Amount,
                    hideCurrencySymbol: true,
                  });
                  return `<div class="arrow_box donut-arrow-box"><span class="value">${amount} ${unitText}</span></div>`;
                },
                followCursor: true, // vị trí theo chuột
              },
              colors: ['#FF9800', primaryColor],
              labels: ['Tiền gửi', 'Tiền mặt'],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: 0,
              },
              plotOptions: {
                pie: {
                  donut: {
                    background: 'transparent',
                    labels: {
                      // Hiện ở bên trong donut
                      show: true,
                      name: {
                        show: true,
                        fontSize: (26 * width) / 400,
                        fontFamily: 'NotoSans-Regular',
                        offsetY: -20,
                        color: undefined,
                        formatter: function (val) {
                          return val;
                        },
                      },
                      value: {
                        show: true,
                        fontSize: (48 * width) / 400,
                        fontFamily: 'NotoSans-Regular',
                        fontWeight: 700,
                        color: undefined,
                        formatter: function (val) {
                          return proxy.$ms.format.formatAmount(val, {hideCurrencySymbol: true});
                        },
                      },
                      total: {
                        show: true,
                        showAlways: true,
                        label: 'Tổng số dư',
                        color: '#000',
                        formatter: function (w) {
                          let sum = w.globals.seriesTotals.reduce((a, b) => {
                            return a + b;
                          }, 0);
                          return proxy.$ms.format.formatAmount(sum, {hideCurrencySymbol: true});
                        },
                      },
                    },
                  },
                },
              },
              legend: {
                fontSize: '13px',
                fontFamily: 'NotoSans-Regular',
                fontWeight: 600,
                position: 'bottom',
                horizontalAlign: 'center',
                width: '300px',
                inverseOrder: true,
                itemMargin: {
                  horizontal: 10,
                  vertical: 8,
                },
                labels: {
                  colors: '#111111',
                  useSeriesColors: false,
                },
                markers: {
                  radius: 3,
                  shape: 'square',
                },
              },
            },
          };
      }
    }
  };

  /**
   * custom lại title theo kỳ báo cáo
   * ntduong2 4.3.2024
   */
  const getCustomtitle = (paramValue, preTitle) => {
    let subTitle = commonFunction.getTitleByDateRange(paramValue.fromDate, paramValue.toDate);
    return `${preTitle} ${subTitle}`;
  };

  /**
   * @function
   * @description Gọi api lưu lại tham số của dashboard
   * @author NXHung 17.05.2024
   * @param {*} param
   */
  const saveDashBoardParam = async (param, paramKey) => {
    await dashboardParamApi
      .saveDashBoardParam(param)
      .then(res => {
        updateDashboardData(res, paramKey, param.Model, true);
      })
      .finally(() => {
        commonFunction.unmask();
      });
  };

  /**
   * @function
   * @description Cập nhật lại thông tin dữ liệu vào dashboard sau khi lưu
   * @author NXHung 17.05.2024
   * @param {*} data
   * @param {*} paramKey
   */
  const updateDashboardData = async (data, paramKey, param, isUpdateParam = false, count = 0) => {
    var currentData = useDashboardDataStore().items;
    const indexDb = new IndexedDB();
    if (paramKey == 'dashboard_budget_plan') {
      // nếu không có group nào = 10 thì get lại thông tin - BUG 193665 - Do khi dữ liệu mới thì thông tin dashboard không load lại mà lấy ra từ indexDb (tại đây k có thông tin ava)
      // kiểm tra nếu không có thông báo ava nào thì call api load lại
      let findItems = data.filter(x => x.dashboard_group == 10);
      if (!findItems || findItems.length == 0) {
        let data = await indexDb.get(paramKey);
        let paramParsed = null;
        if (data) {
          paramParsed = JSON.parse(data?.param);
        } else {
          paramParsed = param;
        }
        if (paramParsed) {
          let param = {
            Model: paramParsed,
          };
          if (count == 0) {
            //  Gọi service lấy dữ liệu ngay
            await dashboardParamApi.handleDashboardParamImmediately(param).then(res => {
              updateDashboardData(res, paramKey, paramParsed, true, 1);
            });
          }
        }
      } else {
        // thực hiện xử lí thông báo ava hiển thị
        dashboardMessageGroup.value = handleDashboardMessageGroup(data);

        // cập nhật lại vào data
        data.forEach(item => {
          let findItem = dashboardMessageGroup.value.find(x => x.id == item.id);
          if (findItem) {
            item = findItem;
          }
        });
      }
    }

    currentData = currentData.filter(x => x.dashboard_param_key != paramKey);
    data.forEach(x => currentData.push(x));

    useDashboardDataStore().items = currentData;

    let currentGroup = dashboardDataGroup.find(x => x.paramKey == paramKey);

    let paramValueParsed = JSON.parse(param.dashboard_param_value ?? '{}');

    currentGroup.groupData.forEach(x => {
      if (paramValueParsed.toDate) {
        x.customTitle = getCustomtitle(paramValueParsed, x.title);
        x.toDate = paramValueParsed.toDate;
      }
    });

    //  Nếu được gắn cờ update Param thì cập nhật lại expired_date
    if (isUpdateParam) {
      //  Nếu không có param được truyền vào thì lấy param đã được lưu ở trong indexdb
      if (!param) {
        let paramIndexDB = await indexDb.get(paramKey);

        param = JSON.parse(paramIndexDB.param) ?? {};
      }
      param.expired_date = moment().add(_appConfig.dashboardExpiredTime, 'seconds').utc().format();

      //  Set lại giá trị cho indexdb
      indexDb.set(paramKey, {
        data: JSON.stringify(data),
        param: JSON.stringify(param),
      });
    }

    commonFunction.updateTitlePageWhenOpenScreen(proxy.$ms.constant.ScreenCode.Dashboard);
  };

  /**
   * Format dashboard message group titles with proper styling
   * @param {Array} finalRs - Array of dashboard message items
   * @returns {Array} - Processed array with formatted titles
   */
  const handleDashboardMessageGroup = data => {
    let finalRs = data.filter(x => x.dashboard_group == 10 && x.is_show == true);
    // nếu đang kết nối quản lí ts thì bỏ tbao qlts
    if (isUseQLTS) {
      finalRs = finalRs.filter(x => !x.dashboard_param_key.startsWith('fixed_asset'));
    }
    //sort  theo sort_order từ nhỏ tới tới
    finalRs.sort((a, b) => a.sort_order - b.sort_order);
    let result = finalRs.map(item => {
      // Clone the item to avoid mutation issues
      const processedItem = {...item};

      if (
        item.quantity > 0 &&
        item.dashboard_param_key !== 'invalid_account_111' &&
        item.dashboard_param_key !== 'invalid_account_112'
      ) {
        // Case 1: Bold quantity + original title
        processedItem.title = `<strong style="font-size: 16px;">${item.quantity}</strong> ${item.title}`;
      } else if (
        item.dashboard_param_key === 'invalid_account_111' ||
        item.dashboard_param_key === 'invalid_account_112'
      ) {
        // Case 2: Original title + red formatted amount
        const formattedAmount = proxy.$ms.format.formatData(item.debit_amount, {
          formatType: proxy.$ms.constant.FormatType.Amount,
        });
        processedItem.title = `${item.title} <span style="color: red;">${formattedAmount}</span>`;
      }

      return processedItem;
    });
    return result;
  };

  return {
    getCustomData,
    getCustomtitle,
    getCustomOption,
    saveDashBoardParam,
    updateDashboardData,
    dashboardMessageGroup,
    handleDashboardMessageGroup,
  };
};
